<template>
  <div>
    <!-- Erreur 403 - Fonctionnalité indisponible -->
    <UnauthorizedAccess
        v-if="error?.statusCode === 401"
        :required-permissions="error?.data?.requiredPermissions"
        :requested-path="error?.data?.requestedPath"
        :user-permissions="error?.data?.userPermissions"
    />

    <!-- Erreur 404 - Page non trouvée -->
    <PageNotFound
        v-else-if="error?.statusCode === 404"
        :requested-path="$route?.path"
    />

    <!-- Autres erreurs -->
<!--    <div v-else class="min-h-screen flex items-center justify-center bg-gray-50">-->
<!--      <div class="text-center">-->
<!--        <h1 class="text-4xl font-bold text-gray-800 mb-4">-->
<!--          Erreur {{ error?.statusCode }}-->
<!--        </h1>-->
<!--        <p class="text-gray-600 mb-8">{{ error?.statusMessage }}</p>-->
<!--        <Button-->
<!--            :label="$t('errors.notFound.backHome')"-->
<!--            icon="pi pi-home"-->
<!--            class="p-button-lg"-->
<!--            @click="navigateTo('/')"-->
<!--        />-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script setup lang="ts">
const error = useError()

// Log de l'erreur pour le debug
// console.log('Error page:', error.value)
</script>